import './bottom.scss'
import {useState} from 'react'
import companyUtil from "../../utils/companyUtil";

type propsType = {
    setPropsCurrentIndex: Function,  //修改首页选中下标
}
const TabBar: React.FunctionComponent<propsType> = (props) => {
    const [list] = useState([
        {name: "首页"},
        {name: "关于我们"},
        {name: "我的产品"},
        {name: "联系我们"},
    ])

    return (
        <div className="BottomTabBarBox">
            <div className="content">
                <div className="leftBox">
                    <div className="listBox">
                        {
                            list.map((item, index) => {
                                return (
                                    <div key={index} onClick={() => props.setPropsCurrentIndex(index)}>
                                        <p className="tabBarText">{item.name}</p>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="addressBox">

                        {/*<p className="addressText">地址：{companyUtil.location}</p>*/}
                        <p className="addressText">©2018 {companyUtil.name} 版权所有
                            <a className="beiAnHao" onClick={() => window.open("https://beian.miit.gov.cn")}> {companyUtil.icp}</a>
                        </p>
                    </div>
                </div>
                <div className="rightBox">
                    <p style={{color: "white", fontSize: "22px", marginRight: "30px"}}>{companyUtil.short_name}</p>
                </div>
            </div>
        </div>
    )
}

export default TabBar
